import { LoadingOverlay, Box, Progress, Group, Text } from "@mantine/core";
import { useEffect } from "react";
import { useState } from "react";

const Usage = () => {
    const [loading, setLoading] = useState(false);

    // Example usage data (you can replace these with actual data)
    const usageData = {
        members: { current: 75, total: 100 },
        products: { current: 60, total: 100 },
        income: { current: 4000, total: 10000 },
        sales: { current: 90, total: 100 }
    };

    const fetchUsageData = async () => {
    }

    useEffect(() => {

    }, [])

    const renderProgressBox = (label, data) => (
        <Box mb={20}>
            <Group position="apart" mb={5}>
                <Text>{label}</Text>
                <Text size="sm" color="dimmed">
                    {data.current}/{data.total}
                </Text>
            </Group>
            <Progress
                value={(data.current / data.total) * 100}
                label={`${Math.round((data.current / data.total) * 100)}%`}
            />
        </Box>
    );

    return (
        <>
            <LoadingOverlay visible={loading} overlayBlur={2} />
            <div className="expenses container">
                <h1>Reporte de uso</h1>
                {renderProgressBox("Miembros", usageData.members)}
                {renderProgressBox("Productos", usageData.products)}
                {renderProgressBox("Ingresos", usageData.income)}
                {renderProgressBox("Ventas", usageData.sales)}
            </div>
        </>
    );
}

export default Usage;